import Model from './Model'
import SubCategory from './SubCategory'

export default class Category extends Model {
  id: number
  title: string
  imageId: number
  subCategories: []

  constructor(json, locale) {
    super({})
    this.id = json.id
    this.title = this.translateField(json._title, locale)
    this.imageId = json.cached_id
    this.subCategories = json.subcategory.map((subCategory) => new SubCategory(subCategory, locale))
  }
}
